import {Component, Input} from '@angular/core';
import {AlertSettings, FileDetails} from '../../hickory-api/index';

@Component({
  selector: 'app-alert-detail-icons',
  templateUrl: './alert-detail-icons.component.html',
  styleUrls: ['./alert-detail-icons.component.scss'],
  standalone: false
})
export class AlertDetailIconsComponent {
  @Input() alert: AlertSettings = null;

  get hasAttachments(): boolean { return !!this.alert?.message?.files?.length && !this.alert.message.files.every(f => f.fileAttachmentType === FileDetails.FileAttachmentTypeEnum.VoiceMessage); }
}
